import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "reactstrap";
import { evaluateAccessibility } from "../../Utils/Authorization";
import logo from "assets/img/logo-white.svg";
import { useSelector, useDispatch } from "react-redux";
import { resetUserData } from "ReduxStore/Slices/userSlice";
import { resetCampaignData } from "ReduxStore/Slices/campaignSlice";
import { resetTemplateData } from "ReduxStore/Slices/templateSlice";
import SidebarNavLink from "./SidebarNavLink";
import { useHistory } from "react-router-dom";
import $ from "jquery";
export default function Sidebar(props) {
  const user = useSelector((state) => state.userSetter);
  const navigation_toggle = useRef();
  const sidebar_ref = useRef();
  const logoname_ref = useRef();
  const sidebarfooter_ref = useRef();

  const dispatch = useDispatch();
  const history = useHistory();
  const [logout_hover, setLogoutHover] = useState(false);
  const { role } = useSelector(state => state.userSetter)

  const dashboardMenuItems = [];

  const accountsMenuItems = role== 'publisher'? [  { name: "Prospects", url: "/admin/contact/list", allow: true }] :[
    { name: "All Contacts", url: "/admin/contact/list", allow: true },
    { name: "Add Contacts", url: "/admin/contact/add", allow: true },
    { name: "All Audience", url: "/admin/contact/audience/details", allow: true },
    { name: "Create Audience", url: "/admin/contact/audience/create", allow: true },
  ];

  const salesAccountMenu = [
    { name: "All Contacts", url: "/admin/accounts/list", allow: true },
  ]
  const salesMenuItems = [
    { name: "Deals", url: "/admin/sales/deals", allow: true },
    { name: "Tasks", url: "/admin/sales/tasks", allow: true },
    { name: "Meetings", url: "/admin/sales/meetings/calender", allow: true },

  ]

  const campaignMenuItems = [
    { name: "All Campaigns", url: "/admin/campaign/all", allow: true },
    {
      name: "Create Campaign",
      url: "/admin/campaign/create",
      allow:
        user.role === "compliance" && user.companyLevelComplaiceFlag === true
          ? false
          : true,
    },
  ];

  const templateMenuItems = [
    {
      name: "All Templates",
      url: "/admin/templates/all_templates",
      allow: true,
    },
    { name: "Create Templates", url: "/admin/templates/info", allow: true },
    { name: "Content Library", url: "/admin/templates/content", allow: true },
    { name: "Assets", url: "/admin/templates/assets", allow: true },
  ];

  const workflowMenuItems = [
    { name: "All Workflow", url: "/admin/workflow/all_workflows", allow: true },
    {
      name: "Create Workflow",
      url: "/admin/workflow/createAutomation",
      allow: true,
    },
  ];

  const eventsignalMenuItems = [
    {
      name: "All Trigger",
      url: "/admin/triggersAndEvents/allTrigers",
      allow: true,
    },
    {
      name: "All Events",
      url: "/admin/triggersAndEvents/allEvents",
      allow: true,
    },
    {
      name: "Create Trigger",
      url: "/admin/triggersAndEvents/createTrigger",
      allow: true,
    },
    {
      name: "Create Event",
      url: "/admin/triggersAndEvents/createEvent",
      allow: true,
    },
    {
      name: "UTM Builder",
      url: "/admin/triggersAndEvents/UtmlBuilder",
      allow: true,
    },
  ];

  const settings = role =='publisher'? [ { name: "General", url: "/admin/settings/configurations", allow: true }] :[
    { name: "General", url: "/admin/settings/configurations", allow: true },
    { name: "Users", url: "/admin/settings/users", allow: true },
    { name: "Objects", url: "/admin/settings/objects", allow: true },
    { name: "Apps", url: "/admin/settings/all_apps", allow: true },
    { name: "Billing", url: "/admin/settings/payments", allow: true },

  ];
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  const logoutHandler = (e) => {
    // 
    sessionStorage.removeItem("token");
    sessionStorage.setItem("keptLogged", "false");
    localStorage.removeItem("token");
    localStorage.setItem("keptLogged", "false");
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    dispatch(resetUserData());
    dispatch(resetCampaignData());
    dispatch(resetTemplateData());
    history.push("/login");
  };
  const scrollToBottom = (element) => {
    element.scrollTop = element.scrollHeight;
  }
  return (
    <div>
      {" "}
      <div className="sidebar-wrap">


        <div className="sidebar-logo">
          <a className="logo-link navbar-brand has_left_icon" href="#" tabIndex="-1">
            <span className="">
              <img src={logo} />
            </span>{" "}
            <span
              className="logoname"
              ref={logoname_ref}
            >
              Kapitalwise
            </span>
          </a>
          <a
            href="#"
            className="navigation-toggle"
            ref={navigation_toggle}
            onClick={() => {
              sidebar_ref.current.classList.toggle("active");
              logoname_ref.current.classList.toggle("collapsed");
              logoname_ref.current.classList.toggle("collapse-menu");
              sidebarfooter_ref.current.classList.toggle("collapsed");
              sidebarfooter_ref.current.classList.toggle("collapse-menu");

              $(".main-panel").toggleClass("collapsed");
              navigation_toggle.current.classList.toggle("collapse-menu");
            }}
          >


            <span>
              <i className="fas fa-chevron-left"></i>
            </span>
          </a>
        </div>

        <div
          className="Sidebar"
          ref={sidebar_ref}
          data-color={props.backgroundColor}
        >
          {/* <!-- Navbar links --> */}
          <Nav className="navbar navbar-expand-sm flex-column align-items-start">

            <div className="collapse navbar-collapse" id="navbarsExample03">
              <ul className="navbar-nav flex-column">
                {evaluateAccessibility(
                  "/admin/dashboard",
                  <SidebarNavLink
                    menuName={"Dashboard"}
                    menuURL={"/admin/dashboard"}
                    menuItems={dashboardMenuItems}
                    menuIcon={"fas fa-home"}
                    activeRoute={activeRoute}
                  ></SidebarNavLink>
                )}
                {evaluateAccessibility(
                  "/admin/accounts",
                  <SidebarNavLink
                    menuName={role =='publisher'?"Prospects":"Contacts"}
                    menuURL={"/admin/contact"}
                    menuItems={accountsMenuItems}
                    menuIcon={"now-ui-icons icon-dashboard-icons-03"}
                    activeRoute={activeRoute}
                  ></SidebarNavLink>
                )}
{/* 
                {role == "sales" && evaluateAccessibility(
                  "/admin/accounts/sales",
                  <SidebarNavLink
                    menuName={"Contacts"}
                    menuURL={"/admin/accounts"}
                    menuItems={salesAccountMenu}
                    menuIcon={"now-ui-icons icon-dashboard-icons-03"}
                    activeRoute={activeRoute}
                  ></SidebarNavLink>
                )} */}
                {/* {evaluateAccessibility(
                  "/audience",
                  <SidebarNavLink
                    menuName={"Audience"}
                    menuURL={"/admin/audience"}
                    menuItems={audienceMenuItems}
                    menuIcon={"now-ui-icons icon-dashboard-icons-02"}
                    activeRoute={activeRoute}
                  ></SidebarNavLink>
                )} */}
                {evaluateAccessibility(
                  "/sales",
                  <SidebarNavLink
                    menuName={"Sales"}
                    menuURL={"/admin/sale"}
                    menuItems={salesMenuItems}
                    menuIcon={"fas fa-compass"}
                    activeRoute={activeRoute}
                  ></SidebarNavLink>
                )}
                {evaluateAccessibility(
                  "/campaign",
                  <SidebarNavLink
                    menuName={"Campaign"}
                    menuURL={"/admin/campaign"}
                    menuItems={campaignMenuItems}
                    menuIcon={"now-ui-icons icon-campaign"}
                    activeRoute={activeRoute}
                  ></SidebarNavLink>
                )}
                {evaluateAccessibility(
                  "/templates",
                  <SidebarNavLink
                    menuName={"Content"}
                    menuURL={"/admin/templates"}
                    menuItems={templateMenuItems}
                    menuIcon={"now-ui-icons icon-event-02"}
                    activeRoute={activeRoute}
                  ></SidebarNavLink>
                )}
                {evaluateAccessibility(
                  "/workflow",
                  <SidebarNavLink
                    menuName={"Engagement Builder"}
                    menuURL={"/admin/workflow"}
                    menuItems={workflowMenuItems}
                    menuIcon={"fas fa-tachometer-alt"}
                    activeRoute={activeRoute}
                  ></SidebarNavLink>
                )}
                {evaluateAccessibility(
                  "/triggersAndEvents",
                  <SidebarNavLink
                    menuName={"Tags"}
                    menuURL={"/admin/triggersAndEvents"}
                    menuItems={eventsignalMenuItems}
                    menuIcon={"fa fa-bolt"}
                    activeRoute={activeRoute}
                  ></SidebarNavLink>
                )}
                {evaluateAccessibility(
                  "/settings",
                  <SidebarNavLink
                    menuName={"Settings"}
                    menuURL={"/admin/settings"}
                    menuItems={settings}
                    menuIcon={"fa fa-cog"}
                    activeRoute={activeRoute}
                  ></SidebarNavLink>
                )}
                <li>
                  <NavLink
                    onClick={() => logoutHandler()}
                    // tabIndex="-1"
                    activeClassName="active"
                    className="nav-link has_left_icon"
                    to=""
                    onMouseOver={() => {
                      setLogoutHover(true);
                    }}
                    onMouseLeave={() => {
                      setLogoutHover(false);
                    }}
                  >
                    <span className="menu_icon">
                      <span className="svg_outer">
                        {logout_hover ? (
                          <span
                            className="now-ui-icons icon-switch"
                            style={{
                              color: "#2C40CE",
                              transition: "0.3s ease-in-out",
                            }}
                          ></span>
                        ) : (
                          <span className="now-ui-icons icon-switch"></span>
                        )}
                      </span>
                    </span>
                    Logout:
                    <p id="logout-email" style={{ textTransform: "lowercase" }}>
                      <span style={{fontSize:'11px'}} >{user.userEmail}</span>
                    </p>
                  </NavLink>
                </li>
              </ul>
            </div>
          </Nav>

        </div>
        <div className="sidebar-footer"
          ref={sidebarfooter_ref}
          onClick={(e) => { scrollToBottom(document.getElementsByClassName('Sidebar')[0]) }}
        >
          <i class="fa fa-angle-double-down" aria-hidden="true"></i>

        </div>
      </div>
    </div>
  );
}
